import { NsContent } from 'components/common/ns-content/NsContent';
import { NsProgress } from 'components/common/ns-progress/NsProgress';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { actionUrl } from 'config/static-content';

export const testId = 'orderCompleteHeaderTestId';

export const OrderCompleteHeader = () => {
  return (
    <NsContent data-testid={testId}>
      <NsSecondaryCta icon="arrow-left" href={actionUrl.bgHome} target="_self">
        British Gas homepage
      </NsSecondaryCta>
      <NsProgress />
    </NsContent>
  );
};

export default OrderCompleteHeader;
